import styled, { css } from 'styled-components';
import { playFontSize } from '../helpers';
import { extraLightCoolGrey, lightYellow, fontWeightBold, fontWeightRegular } from '../../design-tokens';
import { device } from '../../breakpoints';
// eslint-disable-next-line import/no-cycle
import { SIZE } from './PlayText';

const getFontSize = (size: SIZE) => {
    switch (size) {
        case SIZE.MINI:
            return `${playFontSize(1.2)}`;
        case SIZE.SMALL:
            return `${playFontSize(1.4)}`;
        case SIZE.DEFAULT:
            return `${playFontSize(1.5)}`;
        case SIZE.LARGE:
            return `${playFontSize(1.6)}`;
        case SIZE.XLARGE:
            return `${playFontSize(1.8)}`;
        case SIZE.XXLARGE:
            return `${playFontSize(2)}`;
        default:
            return `${playFontSize(1.5)}`;
    }
};

const getFontSizeGteSmall = (size: SIZE) => {
    switch (size) {
        case SIZE.MINI:
            return `${playFontSize(1.3)}`;
        case SIZE.SMALL:
            return `${playFontSize(1.5)}`;
        case SIZE.DEFAULT:
            return `${playFontSize(1.6)}`;
        case SIZE.LARGE:
            return `${playFontSize(1.7)}`;
        case SIZE.XLARGE:
            return `${playFontSize(2.2)}`;
        case SIZE.XXLARGE:
            return `${playFontSize(3)}`;
        default:
            return `${playFontSize(1.6)}`;
    }
};

export type PlayTextStylesProps = {
    weight?: string | number;
    fontColor?: string;
    size?: SIZE;
    error?: boolean;
    underline?: boolean;
    as?: keyof JSX.IntrinsicElements;
};

export const PlayTextStyles = css<PlayTextStylesProps>`
    line-height: 1.4;
    margin: 0;
    font-weight: ${(props: PlayTextStylesProps) => (props.weight ? props.weight : fontWeightRegular)};
    color: ${(props: PlayTextStylesProps) => (props.fontColor ? props.fontColor : extraLightCoolGrey)};
    ${(props: PlayTextStylesProps) => getFontSize(props.size)};

    ${(props: PlayTextStylesProps) =>
        props.error &&
        css`
            color: ${lightYellow};
            font-weight: ${fontWeightBold};
            font-style: normal;
        `}

    @media ${device.GteSmall} {
        ${(props: PlayTextStylesProps) => getFontSizeGteSmall(props.size)}
    }

    text-decoration: ${(props: PlayTextStylesProps) => (props.underline ? 'underline' : 'none')};
`;

export const StyledPlayText = styled.p<PlayTextStylesProps>`
    ${PlayTextStyles}
`;

export const PlayTextError = styled.p`
    color: ${lightYellow};
    font-weight: ${fontWeightBold};
    font-style: normal;
`;
